var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.984 21H4C3.448 21 3 20.552 3 20V14C3 13.448 3.448 13 4 13H5.984C6.536 13 6.984 13.448 6.984 14V20C6.984 20.552 6.536 21 5.984 21Z",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9604 16.9991H15.2844C15.7154 16.9991 16.1344 16.8591 16.4794 16.5991L18.8854 14.7871C19.4864 14.3351 20.3264 14.3951 20.8574 14.9281V14.9281C21.4464 15.5201 21.4464 16.4791 20.8574 17.0701L18.7934 19.1431C18.2374 19.7011 17.5294 20.0821 16.7574 20.2371L13.8384 20.8231C13.2604 20.9391 12.6634 20.9251 12.0904 20.7811L9.45138 20.1191C9.13638 20.0391 8.81138 19.9991 8.48538 19.9991H6.98438",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9604 17H14.4394C15.2724 17 15.9484 16.322 15.9484 15.485V15.182C15.9484 14.487 15.4774 13.881 14.8054 13.713L12.5224 13.14C12.1514 13.047 11.7704 13 11.3884 13V13C10.4654 13 9.56238 13.274 8.79438 13.789L6.98438 15",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2854 3.66068L14.9364 4.03368L14.5864 3.66068C13.8194 2.84268 12.5474 2.77568 11.6994 3.50768C10.8324 4.25568 10.7294 5.55268 11.4424 6.45068C12.4624 7.73468 13.6314 9.00268 14.9364 9.99968C16.2744 8.97768 17.4684 7.67168 18.5064 6.35468C19.1804 5.49968 19.0414 4.25868 18.2194 3.54768L18.1814 3.51468C17.3254 2.77568 16.0524 2.84268 15.2854 3.66068Z",
    fill: "url(#paint0_linear_6853_16898)",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6853_16898",
    x1: 10.9707,
    y1: 3,
    x2: 25.2793,
    y2: 4.92434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGive);
export default __webpack_public_path__ + "static/media/give.22af4925746aaab662dbb1deba438bae.svg";
export { ForwardRef as ReactComponent };